import Axios from "axios"

export default {

  /**
   * 类型列表
   */
  typeList() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/getCustomerIdentity`);
  },

  /**
   * 标记
   * @param {*} project_customer_id 
   * @param {*} project_customer_identity_type 
   * @param {*} external_staff_tag_ids
   */
  mark(
    project_customer_id,
    project_customer_identity_type,
    external_staff_tag_ids
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/externalStaff/markConfirmCustomerToExternalStaff`, {
      project_customer_id,
      project_customer_identity_type,
      external_staff_tag_ids
    });
  }

}